// extracted by mini-css-extract-plugin
export default {"label":"styles_label__O9iNN","data":"styles_data__faMqL","dataContainer":"styles_dataContainer__thugb"};